import { Button, Flex, Loader, Text } from '@mantine/core';

import { getCandidateCountLabel } from '../utils/getCandidateCountLabel';

type RecommendedCandidatesProps = {
  candidatesCount: number;
  isError: boolean;
  isLoading: boolean;
  onPick?: () => void;
};

export const RecommendedCandidates = ({
  candidatesCount,
  isError,
  isLoading,
  onPick,
}: RecommendedCandidatesProps) => {
  return (
    <Flex
      gap={16}
      justify='space-between'
      align='stretch'
      bg='secondary.0'
      p={24}
    >
      <Flex direction='column' gap={16} flex={1} miw={0}>
        <Flex direction='column' gap={4}>
          <Text size='lg' fw={600} c='primary.7'>
            Рекомендованные кандидаты
          </Text>
          <Text size='sm' c='tertiary.7'>
            Нажмите кнопку «Посмотреть», чтобы ознакомиться с кандидатами
          </Text>
        </Flex>

        {onPick && (
          <Button size='md' w='fit-content' onClick={onPick}>
            Посмотреть
          </Button>
        )}

        {isLoading && (
          <Loader size='sm' aria-label='Loading recommended candidates' />
        )}

        {isError && (
          <Text size='sm' c='red.7' role='alert'>
            Не удалось загрузить рекомендованных кандидатов
          </Text>
        )}
      </Flex>

      {!isLoading && !isError && (
        <Flex
          direction='column'
          align='center'
          justify='center'
          gap={8}
          w={128}
          miw={112}
          p={16}
          bg='secondary.7'
          c='white'
          style={{ borderRadius: 16 }}
        >
          <Text c='inherit' fz={48} lh={1} fw={400}>
            {candidatesCount}
          </Text>
          <Text c='inherit' size='md' ta='center'>
            {getCandidateCountLabel(candidatesCount)}
          </Text>
        </Flex>
      )}
    </Flex>
  );
};
